module.exports = __webpack_public_path__ + "img/创建引脚2.2a4a4a7a.svg";